
/* eslint-disable max-len */
import React, { useEffect } from 'react'
import { useState,useRef,useContext } from 'react'
import { useOnClickOutside } from '../../../../../../CommonMethods/OutsideClick'
import {useSearchParams} from  'react-router-dom'
import { useSelector } from 'react-redux'
import { motion } from 'framer-motion'
import Loader from '../../../../../../components/Loader'
import GlobalContext from '../../../../../../components/Context/GloablContext'
import { openExportTab, trackLargeExport } from '../../../../../../CommonMethods/LargeExport'
export default function OrgActivityExportFunction({exportOrgexport,exportCols,isColumnSelect,setIsColumnSelect,TotalCount}) {
    const { setToastmessage, UpdateCall, setUpdateCall,setToastErrorMessage ,isSideBar} = useContext(GlobalContext)
    const [searchParams,setSearchParams]=useSearchParams()
    const organization_id=useSelector((state)=>state?.systemConfigData?.organization_id)
    /* This code is filtering out specific parameters from the `searchParams` object. */
    const excludedParams = ['page_number', 'limit'];
    const filteredParams = {};
    let queryString
    
    for (const [key, value] of searchParams.entries()) {
        if (!excludedParams.includes(key)) {
            filteredParams[key] = value;
        }
    }
    filteredParams["sort"]="timestamp+desc"
    queryString = Object.keys(filteredParams)
        .map(key => `${key}=${encodeURIComponent(filteredParams[key])}`)
        .join('&');
    
    const [exportLoading,setExportLoading]=useState(false)
    
    const [isCheckedAll,setIsCheckedAll] = useState(false)
    const [checkedArr,setCheckedArr] = useState(exportCols)
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const ref=useRef()
    function handleIsCheckedAll(){
        setIsCheckedAll(!isCheckedAll)
        if(!isCheckedAll){
            setCheckedArr(exportCols)
        }
        else{
            setCheckedArr([])
        }
    }
    async function handleExport(){
        const sort=queryString
        
        function camelToSnakeCase(str) {
            if(str==="Username"){
                return "user_name"
            }
            else if(str==="Timestamp"){
                return "timestamp"
            }
            else if(str==="Table Name"){
                return "table_name"
            }
            else if(str==="Filter by"){
                return "filters_applied"
            }
            else if(str==="Exported column Name"){
                return "columns_selected"
            }
            else{
                return str.replace(/ /g, '_').toLowerCase();
                // return str.replace(/[ +]/g, '_').toLowerCase();
            }
        }
        
        let columns
        if(exportCols.includes('Username')){
            columns=checkedArr.map(camelToSnakeCase)
        }
        setExportLoading(true)
        let payload={}
        payload={columns,dateformat,organization_id}
        
        const exportTab = openExportTab(TotalCount)
        const exportRes=await exportOrgexport(payload)
        setExportLoading(false)
        if (!trackLargeExport(exportRes?.data, { exportTab, setToastmessage, setToastErrorMessage })) {
            window.open(exportRes?.data.presigned_url)   

            if(exportRes?.error){
                setToastErrorMessage("Something went wrong")
            }
            else{
                setToastmessage(exportRes?.data?.message)   
            }
        }
        
        setIsColumnSelect(!isColumnSelect)
        setCheckedArr(exportCols) 

    }
    useOnClickOutside(ref, () => {
        setIsColumnSelect(false);
    });
    function handleIndividualSelect(column){
        if(checkedArr.includes(column)){
            let filteredArr=checkedArr?.filter((item)=>item!==column)
            setCheckedArr(filteredArr)
            setIsCheckedAll(false)
        }
        else{
            setCheckedArr((prev)=>([
                ...prev,
                column
            ]))

        }
    }
    useEffect(()=>{
        if(checkedArr.length===exportCols.length){
            setIsCheckedAll(true)
        }
        else{
            setIsCheckedAll(false)
        }
    },[checkedArr])
    useEffect(()=>{
        if(isColumnSelect){
            setCheckedArr(exportCols)
        }
    },[isColumnSelect])
    return (
        <>
            <button id="icon-export" 
                onClick={()=>{setIsColumnSelect(!isColumnSelect)}}
                className="ml-2.5 border border-[#972E4C] rounded-[15px] px-[15px] py-[13px]">
                <img src="/images/download-red.svg" alt="download-icon" />
            </button>
            {isColumnSelect&&
            <motion.div
                initial={{ opacity: 0, x: 80,y:-46 }}
                animate={{ opacity: 1, x: 0 ,y:-46}}
                transition={{ delay: 0.2, duration: 0.5 }}
                exit={{ opacity: 0.5 }}
                className='z-[999] bg-white absolute top-[148px] right-[0px]'
            >
                <div ref={ref} className='border border-[#EEB9BC] rounded rounded-tr-none rounded-br-none pl-3.5 pr-2.5 py-4 shadow-s4 bg-white min-w-[200px]'>
                    <div className='flex items-center justify-between mb-4'>
                        <p className='text-xs font-semibold text-[#031624]'>Select columns to export</p>
                        <button type='button' onClick={()=>setIsColumnSelect(!isColumnSelect)}>
                            <img src="/images/cross_mark_color.svg" alt="icon" />
                        </button>
                    </div>
                    <ul>
                        <li className='flex justify-between items-center mb-4'>
                            <div className="relative checkbox custom-checkBoxBlue1">
                                <input type="checkbox" id='id1' checked={isCheckedAll} onChange={handleIsCheckedAll} className='prevent-click' />
                                <label htmlFor='id1' className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4">All</label>
                            </div>
                            <button onClick={()=>{setCheckedArr([])}} type='button' className={checkedArr?.length===0?'hidden':`text-xs font-semibold text-[#863B50]`}>
                                Clear All
                            </button>
                        </li>
                        <li className='overflow-y-auto max-h-max4 scrollBar_green_thin'>
                            <ul>
                                {exportCols.map((column)=>(
                                    <li  key={column} className='mb-4'>
                                        <div  className="relative checkbox custom-checkBoxBlue1">
                                            <input type="checkbox" id={column}  onChange={()=>handleIndividualSelect(column)} checked={checkedArr.includes(column)?true:false}  className='prevent-click' />
                                            <label htmlFor={column} className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4">{column}</label>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </li>
                    </ul>
                    <div className='mt-[46px]'>
                        <button id="Export" onClick={handleExport} disabled={exportLoading||checkedArr.length===0}
                            className={`py-2.5 px-4 flex items-center justify-center text-base font-normal text-[#fff] rounded-[16px] 
           ${exportLoading||checkedArr.length===0?'bg-[#777C88]':'bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50]'}  w-full`}>
                            {!exportLoading&&<img src="/images/download_icon_white.svg" alt="icon" />}
                            {exportLoading?<span className='pl-2.5'>{<Loader/>}</span>:<span className='pl-2.5'>Export</span>}
                        </button>
                    </div>
                </div>
            </motion.div>}
        </>
    )
}
